import { render } from "./ColorItem.vue?vue&type=template&id=1a01d472&scoped=true"
import script from "./ColorItem.vue?vue&type=script&lang=js"
export * from "./ColorItem.vue?vue&type=script&lang=js"

import "./ColorItem.vue?vue&type=style&index=0&id=1a01d472&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a01d472"]])

export default __exports__